import template from './index.html'
import controller from './controller'

directive.$inject = []
function directive() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: {
      returnState: '<'
    }
  }
}

export default directive